// extracted by mini-css-extract-plugin
export var wordContainer = "_sr-0";